import '../plugins/openClosePlugin';

// open-close init
export default function initOpenClose() {
	jQuery('.filter').openClose({
		activeClass: 'active',
		opener: '.opener',
		slider: '.slide',
		hideOnClickOutside: true,
		animSpeed: 400,
		event:'click',
		effect: 'none',
		onInit: function(self) {
			jQuery('.filter').each(function() {
				var $filter = $(this);
				$filter.find('.filter-label').on('click', function() {
					$filter.removeClass('active');
					$filter.find('.slide').addClass('js-slide-hidden');
				});
			});
		}
	});
	
	
	
	ResponsiveHelper.addRange({
		'..768': {
			on: function() {
				jQuery('.card-row').openClose({
					activeClass: 'active',
					opener: '.opener',
					slider: '.slider',
					animSpeed: 400,
					effect: 'slide'
				});
				jQuery('.open-close-mobile').openClose({
					activeClass: 'active',
					opener: '.opener',
					slider: '.slide',
					animSpeed: 400,
					effect: 'slide',
				});
			},
			off: function() {
				jQuery('.card-row').openClose('destroy');
				jQuery('.open-close-mobile').openClose('destroy');
			}
		}
	});
	

	let $openClose = jQuery('.filter-selected');
	
	let options = {
		activeClass: 'filter-active',
		opener: '.opener',
		slider: '.slide',
		animSpeed:300,
		event: 'hover',
		effect: 'slide',
		onInit: function(self) {
			let links = self.slider.find('.filter-label span');
			let $opener = self.opener.find('.inner-text');
			let btn = self.opener.find('.btn-clear-opener');
			let value = self.opener.find('.inner-text').text();
			btn.each(function() {
				jQuery(this).click(function(e){
					e.preventDefault();
					jQuery(this).closest('.filter-selected').removeClass('item-selected')
					jQuery(this).siblings('.inner-text ').text( value);
					
				})
			})
			function onClick(e) {
				let $link = jQuery(e.currentTarget);
				jQuery(this).closest('.filter-selected').addClass('item-selected')
				$opener.text($link.text());
					self.hideSlide();
					e.preventDefault();
			}
			
			links.each(function(){
				jQuery(this).on('click', onClick);
			})
		}
	}
	
	$openClose.openClose(options);
	
}
